import { render, staticRenderFns } from "./playerDetails.vue?vue&type=template&id=4e61a348&scoped=true&"
import script from "./playerDetails.vue?vue&type=script&lang=js&"
export * from "./playerDetails.vue?vue&type=script&lang=js&"
import style0 from "./playerDetails.vue?vue&type=style&index=0&id=4e61a348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e61a348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e61a348')) {
      api.createRecord('4e61a348', component.options)
    } else {
      api.reload('4e61a348', component.options)
    }
    module.hot.accept("./playerDetails.vue?vue&type=template&id=4e61a348&scoped=true&", function () {
      api.rerender('4e61a348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/playerDetails/playerDetails.vue"
export default component.exports